export const EXP_TYPE_CRON = "cron";
export const EXP_TYPE_RATE = "rate";

export const scheduleExpressionTypes = [
    {id: 0, label: " - "},
    {id: 1, label: EXP_TYPE_CRON},
    {id: 2, label: EXP_TYPE_RATE}
] ;

export class ScheduleExpressionObject {
    constructor() {
        this.expression = null;
    }

    static clone = (orig) => {
        if (!orig) return null;
        const clone = new ScheduleExpressionObject();
        if (!orig.expression) return clone;
        if (!orig.expression.type) return clone;
        if (orig.expression.type.id == 1) {
            clone.expression = ScheduleExpressionCronObject.clone(orig.expression);
            return clone;
        }

        if (orig.expression.type.id == 2) {
            clone.expression = ScheduleExpressionRateObject.clone(orig.expression);
            return clone;
        }

        return clone;
    }

    stringify = () => {
        if (!this.expression) return "";
        if (!this.expression.stringify) return "";
        return this.expression.stringify();
    }

    static parse = expressionString => {
        const obj = new ScheduleExpressionObject();
        const type = ScheduleExpressionObject.getTypeFromExpression(expressionString);

        if (type.id === 0) obj.expression = null;
        else if (type.id === 1) obj.expression = ScheduleExpressionCronObject.parse(expressionString);
        else if (type.id === 2) obj.expression = ScheduleExpressionRateObject.parse(expressionString);

        return obj;
    }

    static getTypeFromExpression = expressionString => {
        if (!expressionString) return scheduleExpressionTypes[0];

        if (expressionString.startsWith("rate")) {
            return scheduleExpressionTypes[2];
        }

        if (expressionString.startsWith("cron")) {
            return scheduleExpressionTypes[1];
        }

        return scheduleExpressionTypes[0];
    }
}

/*
ScheduleExpressionObject.prototype.stringify = () => {
    if (!this.expression) return null;
    if (!this.expression.stringify) return null;
    return this.expression.stringify();
}*/


export class ScheduleExpressionCronObject {
    constructor() {
        this.type = scheduleExpressionTypes[1];
        this._minutes = "";
        this._hours = "";
        this._dayOfMonth = "";
        this._month = "";
        this._dayOfWeek = "";
        this._year = "";
    }

    get minutes() {
        return this._minutes;
    }

    set minutes(minutes) {
        this._minutes = minutes;
    }

    get hours() {
        return this._hours;
    }

    set hours(hours) {
        this._hours = hours;
    }

    get dayOfMonth() {
        return this._dayOfMonth;
    } 

    set dayOfMonth(dayOfMonth) {
        this._dayOfMonth = dayOfMonth;
    }

    get month() {
        return this._month;
    }

    set month(month) {
        this._month = month;
    }

    get dayOfWeek() {
        return this._dayOfWeek;
    }

    set dayOfWeek(dayOfWeek) {
        this._dayOfWeek = dayOfWeek;
    }

    get year() {
        return this._year;
    }

    set year(year) {
        this._year = year;
    }

    stringify = () => {
        return `cron(${this._minutes} ${this.hours} ${this.dayOfMonth} ${this.month} ${this.dayOfWeek} ${this.year})`;
    }

    static clone = (orig) => {
        if (!orig) return null;
        //return Object.assign(Object.create(Object.getPrototypeOf(orig)), orig)
        const clone = new ScheduleExpressionCronObject();
        clone.minutes = orig.minutes;
        clone.hours = orig.hours;
        clone.dayOfMonth = orig.dayOfMonth;
        clone.month = orig.month;
        clone.dayOfWeek = orig.dayOfWeek;
        clone.year = orig.year;
        return clone;
    }

    static parse = expressionString => {
        const obj = new ScheduleExpressionCronObject();

        const trimmedExpression = expressionString ? expressionString.replace("cron(", "").replace(")", "") : null;

        console.log("trimmedExpression");
        console.log(trimmedExpression);

        const parts = trimmedExpression ? trimmedExpression.split(" ") : null;
        const validParts = parts && parts.length === 6

        obj.minutes = validParts ? parts[0] : "";
        obj.hours = validParts ? parts[1] : "";
        obj.dayOfMonth = validParts ? parts[2] : "";
        obj.month = validParts ? parts[3] : "";
        obj.dayOfWeek = validParts ? parts[4] : "";
        obj.year = validParts ? parts[5] : "";

        return obj;
    }
}

export class ScheduleExpressionRateObject {
    constructor() {
        this.type = scheduleExpressionTypes[2];
        this._value = 0;
        this._unit = "";
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
    }

    get unit() {
        return this._unit;
    }

    set unit(unit) {
        this._unit = unit;
    }

    stringify = () => {
        return `rate(${this.value} ${this.unit})`;
    }

    static clone = (orig) => {
        if (!orig) return null;
        //return Object.assign(Object.create(Object.getPrototypeOf(orig)), orig)
        const clone = new ScheduleExpressionRateObject();
        clone.value = orig.value;
        clone.unit = orig.unit;
        return clone;
    }

    static parse = (expressionString) => {
        const obj = new ScheduleExpressionRateObject();

        const trimmedExpression = expressionString ? expressionString.replace("rate(", "").replace(")", "") : null;
        const parts = trimmedExpression ? trimmedExpression.split(" ") : null;
        const validParts = parts && parts.length === 2;

        obj.value = validParts ? parts[0] : "";
        obj.unit =  validParts ? parts[1] : "";

        return obj;
    }
}

export const stringifyScheduleExpression = (scheduleExpression) => {
    if (!scheduleExpression) return null;
    if (!scheduleExpression.expression) return null;
    if (!scheduleExpression.expression.type) return null;

    if (scheduleExpression.expression.type.id === 1) {
        return stringifyCronScheduleExpression(scheduleExpression.expression);
    }

    if (scheduleExpression.expression.type.id === 2) {
        return stringifyRateScheduleExpression(scheduleExpression.expression);
    }

    return null;
}

export const stringifyCronScheduleExpression = (cron) => {
    if (!cron) return "cron";
    return `cron(${cron.minutes} ${cron.hours} ${cron.dayOfMonth} ${cron.month} ${cron.dayOfWeek} ${cron.year})`;

}

export const stringifyRateScheduleExpression = (rate) => {
    if (!rate) return "rate";
    return `rate(${rate.value} ${rate.unit})`;

}

/*

cron(minutes hours day-of-month month day-of-week year)
Field	Values	Wildcards
Minutes

0-59

, - * /

Hours

0-23

, - * /

Day-of-month

1-31

, - * ? / L W

Month

1-12 or JAN-DEC

, - * /

Day-of-week

1-7 or SUN-SAT

, - * ? L #

Year

1970-2199

, - * /

Wildcards
The , (comma) wildcard includes additional values. In the Month field, JAN,FEB,MAR includes January, February, and March.

The - (dash) wildcard specifies ranges. In the Day field, 1-15 includes days 1 through 15 of the specified month.

The * (asterisk) wildcard includes all values in the field. In the Hours field, * includes every hour. You can't use * in both the Day-of-month and Day-of-week fields. If you use it in one, you must use ? in the other.

The / (slash) wildcard specifies increments. In the Minutes field, you could enter 1/10 to specify every tenth minute, starting from the first minute of the hour (for example, the 11th, 21st, and 31st minute, and so on).

The ? (question mark) wildcard specifies any. In the Day-of-month field you could enter 7 and if any day of the week was acceptable, you could enter ? in the Day-of-week field.

The L wildcard in the Day-of-month or Day-of-week fields specifies the last day of the month or week.

The W wildcard in the Day-of-month field specifies a weekday. In the Day-of-month field, 3W specifies the weekday closest to the third day of the month.

The # wildcard in the Day-of-week field specifies a certain instance of the specified day of the week within a month. For example, 3#2 would be the second Tuesday of the month: the 3 refers to Tuesday because it is the third day of each week, and the 2 refers to the second day of that type within the month.



*/